module.exports = __webpack_public_path__ + "img/digital_ocean.83135521.png";